import { appDependencies } from './ajs.app.dependencies.js';
import { appConfigBlock  } from './ajs.app.config.js';
import { appRunBlock     } from './ajs.app.run.js';
import { AjsBsModalService } from './ajs.bs-modal.service.js';

angular.module( "gameApp", appDependencies )
.config( appConfigBlock )
.run( appRunBlock )
.service( 'ajsBsModalService', AjsBsModalService )